module.exports = __webpack_public_path__ + "static/media/5d_1.f63c5f37.png";